export const enum PDP_EVENT {
	UPDATE_SETITEM = "PDPEvent.UpdateSetItem",
	UPDATE_CUSTOMIZATION = "PDPEvent.UpdateCustomization",
	UPDATE_SETITEM_CUSTOMIZATION = "PDPEvent.UpdateSetItemCustomization",
}

export enum PDP_INPUT_STATUS {
	BAD = "PDPInputStatus.BadInput",
	OK = "PDPInputStatus.OK",
}
